import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';
import {Singleton} from "../../models/singleton";

export class SingletonDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.SINGLETON, apiHelper);
    }

    public find(filters: Object): Observable<Singleton[]> {
        let url = this.apiHelper.getServiceName() + this.getResource() + '/find';
        let headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, filters, headers, null);
    }
}

export enum ApiStatus {
    OPERATIONAL = 'operational',
    MAINTENANCE = 'maintenance'
}
